import { useCallback, useState } from 'react'
import SelectStore from 'components/common/filters/select-store'
import type { Sport } from 'core/models/api/sports-piloting/sports-piloting'
import { useApiGetSport } from 'core/api/sport/useApiGetSport'
import SelectSport from 'components/common/filters2/filters/select-sport'
import { useTranslation } from 'react-i18next'

interface IFavoriteSportFieldProps {
  onAddSportsToGroup: (value: number[], currentStoreId: number, sports: Sport[]) => void
  disabledItemsIds: number[]
}

const SportFields = ({ onAddSportsToGroup, disabledItemsIds }: IFavoriteSportFieldProps) => {
  const { t } = useTranslation()
  const [currentStoreId, setCurrentStoreId] = useState<number>(null)
  const [newSportsIds, setNewSportsId] = useState<number[]>([])

  const { data: sports } = useApiGetSport({ storeId: currentStoreId }, { enabled: !!currentStoreId })
  const updateCurrentStoreId = (value: number) => {
    setCurrentStoreId(value)
  }

  const handleDepartmentChange = (sportIds: number[]) => {
    setNewSportsId(sportIds)
  }

  const handleValidation = useCallback(() => {
    onAddSportsToGroup(newSportsIds, currentStoreId, sports)
    setNewSportsId([])
  }, [onAddSportsToGroup, newSportsIds, sports])

  return (
    <div className="favorite-sport-fields">
      <SelectStore
        id="user-preferences_select_store"
        storeId={currentStoreId}
        onChange={updateCurrentStoreId}
        hasBottomLine
        disableDefaultStore
      />
      {currentStoreId ? (
        <div style={{ display: 'flex' }}>
          <SelectSport
            id="sport"
            onChange={handleDepartmentChange}
            value={newSportsIds}
            storeId={currentStoreId}
            disabledItemsIds={disabledItemsIds}
            isMultiple
          />
          <button
            type="button"
            style={{ marginTop: '20px' }}
            data-testid="add-favorite-departments"
            className="vtmn-btn vtmn-btn_variant--primary vtmn-btn_size--small"
            disabled={newSportsIds.length === 0}
            onClick={handleValidation}
          >
            {t('add')}
          </button>
        </div>
      ) : null}
    </div>
  )
}
export default SportFields
